module.exports = __webpack_public_path__ + "media/images/flags/16/Martinique-7aed4c0af66eff7110522dc253761c3a.png";